import gsap from "gsap";

class Cursor {
	stateClasses = {
		active: 'cursor--active',
		text: 'cursor--has-text',
	};
	speed = 0.5;
	mouse = {
		x: 0,
		y: 0,
	};
	position = {
		x: 0,
		y: 0,
	};
	constructor($el) {
		this.$el = $el;
		this.$text = this.$el.find('[data-cursor="text"]');

		this.xSet = gsap.quickSetter(this.$el[0], 'left', 'px');
		this.ySet = gsap.quickSetter(this.$el[0], 'top', 'px');

		gsap.ticker.add(this.tickerFunction);
		$(window).on('mousemove', this.mouseMoveHandler);

        console.log('cursor', this);
	}

	mouseMoveHandler = ({ clientX, clientY }) => {
		this.mouse.x = clientX;
		this.mouse.y = clientY;
	};

	tickerFunction = () => {
		const dt = 1.0 - (1.0 - this.speed) ** gsap.ticker.deltaRatio();

		this.position.x += (this.mouse.x - this.position.x) * dt;
		this.position.y += (this.mouse.y - this.position.y) * dt;
		this.xSet(this.position.x);
		this.ySet(this.position.y);
	};

	show = text => {
		this.$text.text(text);
		this.$el.addClass(this.stateClasses.active);
		if (text != '') {
			this.$el.addClass(this.stateClasses.text);
		}
	};

	hide = () => {
		this.$el.removeClass(this.stateClasses.active);
		this.$el.removeClass(this.stateClasses.text);
		this.$text.text('');
	};
}

export default Cursor;